import { useQuery } from '@tanstack/react-query';
import { CourseService, UserService } from '@/services';

export function useUserCourseStatus(loggedIn: boolean, courseId?: string) {
  return useQuery({
    queryKey: ['userCourseStatus'],
    queryFn: () => UserService.getMyCourseStatus(courseId ?? ''),
    enabled: loggedIn && !!courseId,
  });
}

export function useAllCourses() {
  return useQuery({
    queryKey: ['courses'],
    queryFn: async () => CourseService.getCourses(),
  });
}

export function useCourse(enabled: boolean, courseId?: string) {
  return useQuery({
    queryKey: ['courses', courseId],
    queryFn: async () => CourseService.getCourse(courseId ?? ''),
    enabled,
  });
}
